export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

function positive(value: number, fallback: number): number {
  return Number.isFinite(value) && value > 0 ? value : fallback;
}

/** Preserve the complete source inside a destination box without distortion. */
export function containDestinationRect(
  sourceWidth: number,
  sourceHeight: number,
  destination: Rect,
): Rect {
  const safeWidth = positive(sourceWidth, destination.width);
  const safeHeight = positive(sourceHeight, destination.height);
  const scale = Math.min(destination.width / safeWidth, destination.height / safeHeight);
  const width = safeWidth * scale;
  const height = safeHeight * scale;
  return {
    x: destination.x + (destination.width - width) / 2,
    y: destination.y + (destination.height - height) / 2,
    width,
    height,
  };
}

/** Center-crop the source to a destination aspect ratio without stretching it. */
export function coverSourceRect(
  sourceWidth: number,
  sourceHeight: number,
  destinationWidth: number,
  destinationHeight: number,
): Rect {
  const safeSourceWidth = positive(sourceWidth, destinationWidth);
  const safeSourceHeight = positive(sourceHeight, destinationHeight);
  const sourceRatio = safeSourceWidth / safeSourceHeight;
  const destinationRatio = positive(destinationWidth, 1) / positive(destinationHeight, 1);
  let width = safeSourceWidth;
  let height = safeSourceHeight;

  if (sourceRatio > destinationRatio) width = safeSourceHeight * destinationRatio;
  else height = safeSourceWidth / destinationRatio;

  return {
    x: (safeSourceWidth - width) / 2,
    y: (safeSourceHeight - height) / 2,
    width,
    height,
  };
}
